<template>
  <img
    src="/brand/foxstamp/symbol.png"
    alt="FoxStamp"
    width="40"
    height="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
